import React from 'react';
import {
    ArrayField,
    ArrayInput,
    BooleanInput,
    ChipField,
    Create,
    Datagrid,
    DateField,
    Edit,
    email,
    Filter,
    List,
    maxLength,
    ReferenceField,
    ReferenceInput,
    required,
    SelectInput,
    SimpleForm,
    SimpleFormIterator,
    SingleFieldList,
    TextField,
    TextInput,
} from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import {
    BulkDeleteButtonAdmin,
    CustomPagination,
    isAdmin,
    isEmployee,
    isPartner,
    isPartnerService,
    stylesWide,
    ToolbarSave,
    ToolbarSaveAllDeleteAdmin,
} from './utils';

const PartnersFilter = props => (
    <Filter {...props}>
        {!isPartnerService(props.permissions) ? (
            <SelectInput
                label="Поле"
                source="field"
                choices={[
                    { id: 'id', name: 'Id партнера' },
                    { id: 'agent_contracts_id', name: 'Id договора с агентом' },
                    { id: 'name', name: 'Имя партнера' },
                    { id: 'details', name: 'Подробности' },
                    { id: 'email', name: 'Электронная почта' },
                    { id: 'status', name: 'Статус партнера' },
                    { id: 'contact', name: 'Контакты' },
                    { id: 'vat_payer', name: 'Плательщик НДС' },
                    { id: 'succ_report_date', name: 'Последний отправленный отчет' },
                    { id: 'legal_entity_type', name: 'Тип юридического лица' },
                    { id: 'inn', name: 'ИНН' },
                    { id: 'kpp', name: 'КПП' },
                    { id: 'legal_address', name: 'Юридический адрес' },
                    { id: 'bank_credentials', name: 'Банковские реквизиты' },
                    { id: 'created', name: 'Время создания' },
                    { id: 'updated', name: 'Последнее обновление' },
                ]}
                alwaysOn
            />
        ) : (
            <SelectInput
                label="Поле"
                source="field"
                choices={[
                    { id: 'id', name: 'Id ' },
                    { id: 'name', name: 'Имя' },
                    { id: 'details', name: 'Подробности' },
                    { id: 'email', name: 'Электронная почта' },
                    { id: 'status', name: 'Статус' },
                    { id: 'contact', name: 'Контакты' },
                    { id: 'vat_payer', name: 'Плательщик НДС' },
                    { id: 'legal_entity_type', name: 'Тип юридического лица' },
                    { id: 'inn', name: 'ИНН' },
                    { id: 'kpp', name: 'КПП' },
                    { id: 'legal_address', name: 'Юридический адрес' },
                    { id: 'bank_credentials', name: 'Банковские реквизиты' },
                    { id: 'created', name: 'Время создания' },
                    { id: 'updated', name: 'Последнее обновление' },
                ]}
                alwaysOn
            />
        )}
        <TextInput
            label="Поиск"
            source="q"
            alwaysOn
        />
    </Filter>
);

export const PartnersList = ({ permissions, ...props }) => (
    <List
        {...props}
        filters={<PartnersFilter permissions={permissions} />}
        bulkActionButtons={
            isPartnerService(permissions) ? (
                false
            ) : (
                <BulkDeleteButtonAdmin permissions={permissions} />
            )
        }
        pagination={<CustomPagination />}
    >
        {!isPartnerService(permissions) ? (
            <Datagrid rowClick="edit">
                <TextField
                    label="Id партнера"
                    source="id"
                />
                {isEmployee(permissions) && (
                    <ReferenceField
                        label="Агент"
                        source="agent_id"
                        reference="agents"
                        linkType={false}
                        allowEmpty
                    >
                        <TextField source="name" />
                    </ReferenceField>
                )}
                {isEmployee(permissions) && (
                    <ReferenceField
                        label="Франчайзи"
                        source="franchisee_id"
                        reference="franchisee"
                        linkType={false}
                        allowEmpty
                    >
                        <TextField source="name" />
                    </ReferenceField>
                )}
                <TextField
                    label="Имя партнера"
                    source="name"
                />
                <TextField
                    label="Подробности"
                    source="details"
                />
                <ArrayField
                    source="emails"
                    label="Электронная почта"
                >
                    <SingleFieldList linkType={false}>
                        <ChipField source="email" />
                    </SingleFieldList>
                </ArrayField>
                <TextField
                    label="Статус партнера"
                    source="status"
                />
                <TextField
                    label="Контакты"
                    source="contact"
                />
                <TextField
                    label="Плательщик НДС"
                    source="vat_payer"
                />
                <DateField
                    label="Последний отправленный отчет"
                    source="succ_report_date"
                    showTime
                    locales="ru-RU"
                />
                <TextField
                    label="Тип юридического лица"
                    source="legal_entity_type"
                />
                <TextField
                    label="ИНН"
                    source="inn"
                />
                <TextField
                    label="КПП"
                    source="kpp"
                />
                <TextField
                    label="Юридический адрес"
                    source="legal_address"
                />
                <TextField
                    label="Банковские реквизиты"
                    source="bank_credentials"
                />
                <DateField
                    label="Время создания"
                    source="created"
                    showTime
                    locales="ru-RU"
                />
                <DateField
                    label="Последнее обновление"
                    source="updated"
                    showTime
                    locales="ru-RU"
                />
            </Datagrid>
        ) : (
            <Datagrid rowClick="edit">
                <TextField
                    label="Id "
                    source="id"
                />
                <TextField
                    label="Имя "
                    source="name"
                />
                <TextField
                    label="Подробности"
                    source="details"
                />
                <ArrayField
                    source="emails"
                    label="Электронная почта"
                >
                    <SingleFieldList linkType={false}>
                        <ChipField source="email" />
                    </SingleFieldList>
                </ArrayField>
                <TextField
                    label="Статус"
                    source="status"
                />
                <TextField
                    label="Контакты"
                    source="contact"
                />
                <TextField
                    label="Плательщик НДС"
                    source="vat_payer"
                />
                <TextField
                    label="Тип юридического лица"
                    source="legal_entity_type"
                />
                <TextField
                    label="ИНН"
                    source="inn"
                />
                <TextField
                    label="КПП"
                    source="kpp"
                />
                <TextField
                    label="Юридический адрес"
                    source="legal_address"
                />
                <TextField
                    label="Банковские реквизиты"
                    source="bank_credentials"
                />
                <DateField
                    label="Время создания"
                    source="created"
                    showTime
                    locales="ru-RU"
                />
                <DateField
                    label="Последнее обновление"
                    source="updated"
                    showTime
                    locales="ru-RU"
                />
            </Datagrid>
        )}
    </List>
);

export const AddPartner = withStyles(stylesWide)(({ classes, permissions, ...props }) => (
    <Create
        classes={classes}
        {...props}
    >
        <SimpleForm classes={classes}>
            <TextInput
                label="Имя партнера"
                source="name"
                className={classes.wide}
                validate={required()}
            />
            {isAdmin(permissions) && (
                <ReferenceInput
                    perPage={10000}
                    label="Сервисный партнер"
                    source="partner_service_id"
                    reference="partner_services"
                    allowEmpty
                    className={classes.wide}
                >
                    <SelectInput
                        optionText={choice => `${choice.name} (${choice.id})`}
                        className={classes.wide}
                    />
                </ReferenceInput>
            )}
            {isEmployee(permissions) && (
                <ReferenceInput
                    perPage={10000}
                    label="Агент"
                    source="agent_id"
                    reference="agents"
                    allowEmpty
                    className={classes.wide}
                >
                    <SelectInput
                        optionText="name"
                        className={classes.wide}
                    />
                </ReferenceInput>
            )}
            {isEmployee(permissions) && (
                <ReferenceInput
                    perPage={10000}
                    label="Франчайзи"
                    source="franchisee_id"
                    reference="franchisee"
                    allowEmpty
                    className={classes.wide}
                >
                    <SelectInput
                        optionText="name"
                        className={classes.wide}
                    />
                </ReferenceInput>
            )}
            <TextInput
                label="Подробности"
                source="details"
                className={classes.wide}
            />
            <ArrayInput
                label="Электронная почта"
                source="emails"
                className={classes.wide}
            >
                <SimpleFormIterator>
                    <TextInput
                        source="email"
                        validate={email()}
                        className={classes.wide}
                    />
                </SimpleFormIterator>
            </ArrayInput>
            <SelectInput
                label="Статус партнера"
                source="status"
                className={classes.wide}
                choices={[
                    { id: 'active', name: 'active' },
                    { id: 'inactive', name: 'inactive' },
                ]}
            />
            <TextInput
                label="Контакты"
                source="contact"
                className={classes.wide}
            />
            <SelectInput
                label="Плательщик НДС"
                source="vat_payer"
                className={classes.wide}
                choices={[
                    { id: 'yes', name: 'yes' },
                    { id: 'no', name: 'no' },
                ]}
            />
            <TextInput
                label="Тип юридического лица"
                source="legal_entity_type"
                validate={maxLength(3)}
                className={classes.wide}
            />
            <TextInput
                label="ИНН"
                source="inn"
                validate={maxLength(12)}
                className={classes.wide}
            />
            <TextInput
                label="КПП"
                source="kpp"
                validate={maxLength(9)}
                className={classes.wide}
            />
            <TextInput
                label="Юридический адрес"
                source="legal_address"
                validate={maxLength(150)}
                className={classes.wide}
            />
            <TextInput
                label="Банковские реквизиты"
                source="bank_credentials"
                validate={maxLength(150)}
                className={classes.wide}
            />
            {isAdmin(permissions) && (
                <BooleanInput
                    label="Включена автоматическая генерация отчетов"
                    source="enable_generate_report"
                    classes={classes.wide}
                />
            )}
        </SimpleForm>
    </Create>
));

export const EditPartner = withStyles(stylesWide)(({ classes, permissions, ...props }) => {
    return (
        <Edit
            classes={classes}
            {...props}
        >
            <SimpleForm
                classes={classes}
                toolbar={
                    isPartnerService(permissions) ? (
                        <ToolbarSave />
                    ) : (
                        <ToolbarSaveAllDeleteAdmin permissions={permissions} />
                    )
                }
            >
                <TextInput
                    disabled
                    label="Id партнера"
                    source="id"
                    className={classes.wide}
                />
                {isAdmin(permissions) && (
                    <ReferenceInput
                        perPage={10000}
                        label="Сервисный партнер"
                        source="partner_service_id"
                        reference="partner_services"
                        allowEmpty
                        className={classes.wide}
                    >
                        <SelectInput
                            optionText={choice => `${choice.name} (${choice.id})`}
                            className={classes.wide}
                        />
                    </ReferenceInput>
                )}
                {isEmployee(permissions) && (
                    <ReferenceInput
                        perPage={10000}
                        label="Агент"
                        source="agent_id"
                        reference="agents"
                        allowEmpty
                        className={classes.wide}
                    >
                        <SelectInput
                            optionText="name"
                            className={classes.wide}
                        />
                    </ReferenceInput>
                )}
                {isEmployee(permissions) && (
                    <ReferenceInput
                        perPage={10000}
                        label="Франчайзи"
                        source="franchisee_id"
                        reference="franchisee"
                        allowEmpty
                        className={classes.wide}
                    >
                        <SelectInput
                            optionText="name"
                            className={classes.wide}
                        />
                    </ReferenceInput>
                )}
                <TextInput
                    label="Имя партнера"
                    source="name"
                    disabled={isPartner(permissions)}
                    className={classes.wide}
                    validate={required()}
                />
                <TextInput
                    label="Подробности"
                    source="details"
                    disabled={isPartner(permissions)}
                    className={classes.wide}
                />
                <ArrayInput
                    label="Электронная почта"
                    source="emails"
                    className={classes.wide}
                >
                    <SimpleFormIterator>
                        <TextInput
                            source="email"
                            validate={email()}
                            className={classes.wide}
                        />
                    </SimpleFormIterator>
                </ArrayInput>
                <SelectInput
                    label="Статус партнера"
                    source="status"
                    className={classes.wide}
                    choices={[
                        { id: 'active', name: 'active' },
                        { id: 'inactive', name: 'inactive' },
                    ]}
                    disabled={isPartner(permissions)}
                />
                <TextInput
                    label="Контакты"
                    source="contact"
                    className={classes.wide}
                />
                <SelectInput
                    label="Плательщик НДС"
                    source="vat_payer"
                    choices={[
                        { id: 'yes', name: 'yes' },
                        { id: 'no', name: 'no' },
                    ]}
                    disabled={isPartner(permissions)}
                    className={classes.wide}
                />
                <TextInput
                    label="Тип юридического лица"
                    source="legal_entity_type"
                    validate={maxLength(3)}
                    disabled={isPartner(permissions)}
                    className={classes.wide}
                />
                <TextInput
                    label="ИНН"
                    source="inn"
                    validate={maxLength(12)}
                    disabled={isPartner(permissions)}
                    className={classes.wide}
                />
                <TextInput
                    label="КПП"
                    source="kpp"
                    validate={maxLength(9)}
                    disabled={isPartner(permissions)}
                    className={classes.wide}
                />
                <TextInput
                    label="Юридический адрес"
                    source="legal_address"
                    validate={maxLength(150)}
                    disabled={isPartner(permissions)}
                    className={classes.wide}
                />
                <TextInput
                    label="Банковские реквизиты"
                    source="bank_credentials"
                    validate={maxLength(150)}
                    disabled={isPartner(permissions)}
                    className={classes.wide}
                />
                {isAdmin(permissions) && (
                    <BooleanInput
                        label="Включена автоматическая генерация отчетов"
                        source="enable_generate_report"
                        classes={classes.wide}
                    />
                )}
                <TextInput
                    disabled
                    label="Время создания"
                    source="created"
                    showTime
                    className={classes.wide}
                />
                <TextInput
                    disabled
                    label="Последнее обновление"
                    source="updated"
                    showTime
                    className={classes.wide}
                />
            </SimpleForm>
        </Edit>
    );
});
